'use client';

import { Box, Drawer, DrawerBody, Tag } from '@coolblue-development/freddy';
import { useFreddyTranslations } from '@coolblue-development/next-design-system-utils/client';
import { DebugInfo } from '@features/filter/types';
import { type MouseEvent, useState } from 'react';

import { DrawerContent } from './DrawerContent';

const ScoreTag = ({
  debugInfo,
  productName,
  id
}: {
  debugInfo: DebugInfo;
  productName: string;
  id: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const drawerTranslations = useFreddyTranslations('drawer');
  const { score } = debugInfo;

  function handleTagClick(event: MouseEvent<HTMLButtonElement>) {
    event.stopPropagation();
    event.preventDefault();

    setIsOpen(true);
  }

  return (
    <>
      <Tag
        variant='subtle'
        intent='neutral'
        component='button'
        onClick={handleTagClick}
        sx={{ position: 'absolute', top: 0, right: 0, zIndex: 1 }}
      >
        {`Score ${score}`}
      </Tag>
      <Box>
        <Drawer
          open={isOpen}
          placement='right'
          onClose={() => setIsOpen(false)}
          title={`${productName} score`}
          body={
            <DrawerBody>
              <DrawerContent
                debugInfo={debugInfo}
                productInformation={{ fullName: productName, productId: id }}
              />
            </DrawerBody>
          }
          translations={drawerTranslations}
        />
      </Box>
    </>
  );
};

export { ScoreTag };
